import React, { useState } from 'react';

import { useBasketStatusContext } from 'apps/urban/context/basket';
import { useLoginProviderContext } from 'apps/urban/context/login';
import { useRouter } from 'next/router';

import { useMobileView } from '../../hooks/useMobileView';
import { ServiceOSLogin } from '../ServiceOS/ServiceOSLogin/ServiceOSLogin';
import {
  HeaderWrapper,
  HeaderNavMobile,
  HeaderNavDesktop,
  HeaderNavBurgerMobile,
  HeaderLogoSwitchWrapper,
} from './Header.style';
import { THeaderProps } from './Header.types';
import { HeaderBurger } from './HeaderBurger/HeaderBurger';
import { HeaderLanguageSwitch } from './HeaderLanguageSwitch/HeaderLanguageSwitch';
import { HeaderLogo } from './HeaderLogo/HeaderLogo';
import { HeaderMobile } from './HeaderMobile/HeaderMobile';
import { LoginWrapper } from './HeaderMobile/HeaderMobile.style';
import { HeaderNav } from './HeaderNav/HeaderNav';
import { transformNavLoginData } from './util/transform';

export const Header = ({
  logo,
  openLanguageModal,
  locationFlagIcon,
  navigation,
  navigationLogin,
  useServiceOsAuth,
  basketButtonText,
  removeCartButton,
  locationFlagPosition,
  hideBurgerMenu,
  logoWidthOverride,
  logoHeightOverride,
  locationIconWidthOverride,
  locationIconHeightOverride,
}: THeaderProps) => {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const isLoggedIn = useLoginProviderContext();
  const basketContext = useBasketStatusContext();
  const { isMobile } = useMobileView();

  const locationFlagPositionRight = locationFlagPosition === 'right';

  const transformedData = transformNavLoginData(isLoggedIn, navigationLogin, router?.locale);

  const renderLanguageSwitch = () => {
    if (!locationFlagIcon?.filename) return;
    return (
      <HeaderLanguageSwitch
        locationIconWidthOverride={locationIconWidthOverride}
        locationIconHeightOverride={locationIconHeightOverride}
        locationFlagIcon={locationFlagIcon}
        openLanguageModal={openLanguageModal}
      />
    );
  };

  return (
    <HeaderWrapper>
      <HeaderNavDesktop>
        <HeaderLogoSwitchWrapper>
          <HeaderLogo
            logo={logo}
            logoWidthOverride={logoWidthOverride}
            logoHeightOverride={logoHeightOverride}
          />
          {!locationFlagPositionRight && renderLanguageSwitch()}
        </HeaderLogoSwitchWrapper>
        <HeaderNav navigation={navigation} setOpen={setOpen} removeCartButton={removeCartButton} />
        <HeaderNav
          basketData={basketContext?.data}
          showBasket
          navigation={!useServiceOsAuth ? transformedData : []}
          setOpen={setOpen}
          useServiceOsAuth={useServiceOsAuth}
          basketButtonText={basketButtonText}
          removeCartButton={removeCartButton}
        />
        {locationFlagPositionRight && renderLanguageSwitch()}
      </HeaderNavDesktop>
      <HeaderNavMobile>
        <HeaderLogoSwitchWrapper>
          <HeaderLogo
            logo={logo}
            logoWidthOverride={logoWidthOverride}
            logoHeightOverride={logoHeightOverride}
          />
          {!locationFlagPositionRight && renderLanguageSwitch()}
        </HeaderLogoSwitchWrapper>
        <HeaderNavBurgerMobile>
          <HeaderNav
            basketData={basketContext?.data}
            showBasket={!useServiceOsAuth}
            showInitials={isLoggedIn}
            navigation={[]}
            removeCartButton={removeCartButton}
          />
          {locationFlagPositionRight && renderLanguageSwitch()}
          {useServiceOsAuth && isMobile && (
            <LoginWrapper>
              <ServiceOSLogin />
            </LoginWrapper>
          )}
          {!hideBurgerMenu && <HeaderBurger open={open} setOpen={setOpen} />}
        </HeaderNavBurgerMobile>
      </HeaderNavMobile>
      <HeaderMobile
        basketData={basketContext?.data}
        open={open}
        navigation={
          !useServiceOsAuth
            ? isLoggedIn
              ? navigation.concat(navigationLogin.slice(1))
              : navigation.concat(navigationLogin)
            : navigation
        }
        setOpen={setOpen}
        useServiceOsAuth={useServiceOsAuth}
        basketButtonText={basketButtonText}
        removeCartButton={removeCartButton}
      />
    </HeaderWrapper>
  );
};
